import * as React from 'react';
import { gql } from '@apollo/client';
import {
  useGetCategoriesLazyQuery,
  useGetQueueMetadataLazyQuery,
  useGetTimeslotsQuery,
  useGetPostQueueCountLazyQuery
} from '../../../models/graphql';
import { CategoriesController, CategoriesControllerProps } from './Categories.controller';
import { useContext, useMemo } from 'react';
import { AppContext } from '../../../providers/AppProvider';
import { useRequiredQueries } from '../../../hooks/useRequiredQueries';

export type CategoriesApolloProps = {
  isArchivedView: boolean;
};

gql`
  query GetCategories($workspaceId: ID!, $statusFilter: CategoryArchiveFilter = ACTIVE) {
    workspace(workspaceId: $workspaceId) {
      id
      categories(statusFilter: $statusFilter) {
        ...CategoryFields
        seasonal
        seasonalStartDate
        seasonalEndDate
        seasonallyPaused
        archived
        archivedDate
        archivedAttachedPostCount
      }
    }
  }
`;

export const CategoriesApollo = (props: CategoriesApolloProps): JSX.Element => {
  const { selectedWorkspaceId } = useContext(AppContext);
  const getCategoryLazyQuery = useGetCategoriesLazyQuery();
  const [getCategoriesQuery, categoriesResults] = getCategoryLazyQuery;
  const [getQueueMetadataQuery, queueMetadataResults] = useGetQueueMetadataLazyQuery();
  const [getPostQueueCount, postQueueCountResults] = useGetPostQueueCountLazyQuery({ fetchPolicy: 'network-only' });
  const timeslotsResults = useGetTimeslotsQuery({
    variables: { workspaceId: selectedWorkspaceId as string }
  });

  useRequiredQueries([getCategoryLazyQuery]);

  const timeslots = useMemo(() => {
    return timeslotsResults.data?.workspace.timeslots || [];
  }, [timeslotsResults.data?.workspace.timeslots]);

  const controllerProps: CategoriesControllerProps = {
    isArchivedView: props.isArchivedView,
    getCategories: getCategoriesQuery,
    categoriesResults,
    getQueueMetaData: getQueueMetadataQuery,
    queueMetadataResults,
    getPostQueueCount,
    postQueueCountResults,
    queueMetadata: [],
    timeslots
  };

  return <CategoriesController {...controllerProps} />;
};
